import React from "react";
import Switch from "./Components/Switch";
import Input from "./Components/Input";
import Show from "./Components/Show";

export default function({ name }) {
  const [height, setHeight] = React.useState(0.0);
  const [weight, setWeight] = React.useState(0.0);
  const [vti, setVti] = React.useState(0.0);
  const [d, setD] = React.useState(0.0);
  const [pulse, setPulse] = React.useState(0.0);
  const [sbp, setSbp] = React.useState(0.0);
  const [dbp, setDbp] = React.useState(0.0);
  const [rap, setRap] = React.useState(5.0);

  const round = (n, d = 0) => Math.round(n * 10 ** d) / 10 ** d;
  const sv = (d / 2) ** 2 * Math.PI * vti;
  const co = sv * pulse;

  const map = sbp / 3 + (2 * dbp) / 3;
  const svr = (1000 * 80 * (map - rap)) / co;
  const bsa = 0.007184 * weight**.425* height**.725;

  const card = "max-w-sm rounded shadow-lg bg-gray-300 p-2 m-2";
  const title = "font-bold";
  const row = "flex m-2";
  const colLabel = "w-2/3";
  const colInput = "w-1/3 text-center";

  return (
    <div className={card}>
      <p className={title}>Cardiac Output and Stroke Volume Calculator</p>

      <Input label="LVOT Diameter (cm)" onChange={setD} />
      <Input label="LVOT VTI (cm)" onChange={setVti} />
      <Input label="Heart Rate (1/min)" onChange={setPulse} />
      <Input label="RAP (mmHg)" placeholder={rap} onChange={setRap} />
      <Input label="SBP (mmHg)" onChange={setSbp} />
      <Input label="DBP (mmHg)" onChange={setDbp} />
      <Input label="Height (cm)" onChange={setHeight} />
      <Input label="Weight (kg)" onChange={setWeight} />
  
      <div className={title}>
        <Show label="Stroke Volume (mL)" value={round(sv)} />
        <Show label="Cardiac Output (mL/min)" value={round(co)} />
        <Show label="Cardiac Index (mL/min/m²)" value={round(co/bsa)} />
        <Show label="SVR (dynes-sec/cm⁵)" value={round(svr)} />
        <Show label="MAP (mmHG)" value={round(map)} />
        <Show label="BSA - Du Bois (m²)" value={round(bsa, 2)} />

      </div>
      <p className="text-center text-sm">
        Information presented here, including use of the calculator, is strictly for educational purposes and should not be used for any other purpose.
      </p>
      <p className="text-center text-xs">
        © Sami Safadi, MD
      </p>
    </div>
  );
}
